var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16199 10.3691C10.5305 10.3691 12.4509 12.2887 12.451 14.6572C12.451 15.8211 11.5075 16.7646 10.3436 16.7646H2.1073C0.943403 16.7646 -0.00012207 15.8211 -0.00012207 14.6572C3.28316e-06 12.2887 1.92039 10.3691 4.28894 10.3691H8.16199ZM13.7108 10.2402C16.0794 10.2403 17.9999 12.0454 17.9999 14.2715V14.3379C17.9999 15.3945 17.1434 16.251 16.0868 16.251C15.0302 16.251 14.1737 15.3945 14.1737 14.3379V13.5293C14.1737 12.6644 13.8646 11.8645 13.3403 11.2135C13.0766 10.8862 13.2905 10.2402 13.7108 10.2402ZM6.34558 0C8.78629 0 10.746 1.95981 10.746 4.40039C10.7458 6.84163 8.78625 8.80078 6.34558 8.80078C3.90497 8.8007 1.94539 6.84158 1.94519 4.40039C1.94519 1.95986 3.90494 7.58746e-05 6.34558 0ZM12.1591 0.0664062C14.3936 0.0664251 16.1881 1.86036 16.1884 4.09473C16.1884 6.33008 14.3938 8.124 12.1591 8.12402C11.6654 8.12399 11.4927 7.53108 11.7571 7.1142C12.2519 6.33409 12.5379 5.40678 12.538 4.40918C12.5379 3.36232 12.2228 2.39263 11.6818 1.58934C11.27 0.977804 11.4218 0.0664562 12.1591 0.0664062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.5f2b688921e198095760e9f91840ed4a.svg";
export { ForwardRef as ReactComponent };